<template>
  <Head>
    <title>Edit Announcement | NutriStudents K-12</title>
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <div class="flex">
        <U>Settings</U>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1-0 01-1.414 0z" clip-rule="evenodd" />
        </svg>
        <inertia-link :href="route('announcements.index')" class="link-color"><U>Announcements</U></inertia-link>
      </div>
    </BreadcrumLayout>

    <form @submit.prevent="submit">
      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-4/6">
          <h1 class="heading-color 2xl:text-2xl text-xl font-bold">Edit Announcement</h1>
        </div>
        <div class="w-full flex lg:flex-nowrap flex-wrap md:justify-end items-center">
          <inertia-link :href="route('announcements.index')" class="w-full inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase bg-gray-500 text-white focus:outline-none sm:w-40">Cancel</inertia-link>
          <button type="submit" class="menu1-background-color w-full inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase button-color text-white focus:outline-none sm:ml-3 sm:w-40 mt-3 sm:mt-0">Update</button>
        </div>
      </PageTitleLayout>

      <PageTitleLayout>
        <div class="w-full">
          <div class="block justify-between shadow py-8 mt-4 align-middle inline-block min-w-full bg-white rounded-t-lg border-gray-300 w-full">
            <div class="p-5">
              <div class="xl:flex block xl:items-center mb-5">
                <label class="font-bold text-gray-700 2xl:text-lg text-base w-full md:w-40">Title*</label>
                <div class="flex-1">
                  <input type="text" v-model="form.title" class="2xl:text-base text-sm text-gray-600 xl:mt-0 mt-4 w-full shadow-sm focus:border-none block border-gray-300 rounded-lg select-menu-height input-background">
                  <div v-if="form.errors.title" class="validation_error_msg">{{ form.errors.title }}</div>
                </div>
              </div>

              <div class="xl:flex block xl:items-center mb-5">
                <label class="font-bold text-gray-700 2xl:text-lg text-base w-full md:w-40">Publish Date*</label>
                <div class="flex-1">
                  <input type="datetime-local" v-model="form.published_at" class="2xl:text-base text-sm text-gray-600 xl:mt-0 mt-4 w-full shadow-sm focus:border-none block border-gray-300 rounded-lg select-menu-height input-background">
                  <div v-if="form.errors.published_at" class="validation_error_msg">{{ form.errors.published_at }}</div>
                </div>
              </div>

              <div class="xl:flex block xl:items-center mb-5">
                <label class="font-bold text-gray-700 2xl:text-lg text-base w-full md:w-40">Expiry Date</label>
                <div class="flex-1">
                  <input type="datetime-local" v-model="form.expires_at" class="2xl:text-base text-sm text-gray-600 xl:mt-0 mt-4 w-full shadow-sm focus:border-none block border-gray-300 rounded-lg select-menu-height input-background">
                  <div v-if="form.errors.expires_at" class="validation_error_msg">{{ form.errors.expires_at }}</div>
                </div>
              </div>

              <div class="xl:flex block mb-5">
                <label class="font-bold text-gray-700 2xl:text-lg text-base w-full md:w-40 mt-2">Body/Content*</label>
                <div class="flex-1 border-gray-300 bg-gray-100">
                  <quill-editor theme="snow" contentType="html" style="height:300px" id="quill_editor_body"></quill-editor>
                  <div v-if="form.errors.body" class="validation_error_msg">{{ form.errors.body }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageTitleLayout>
    </form>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";

export default {
  props: ['news'],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
  },
  data() {
    return {
      form: this.$inertia.form({
        title: this.news.title,
        body: this.news.body,
        published_at: this.news.published_at_input,
        expires_at: this.news.expires_at_input,
      })
    }
  },
  mounted() {
    const quill = document.querySelector('#quill_editor_body');
    quill.children[0].innerHTML = this.news.body;
  },
  methods: {
    submit() {
      const quill = document.querySelector('#quill_editor_body');
      this.form.body = quill.children[0].innerHTML;
      
      if (this.form.body === "<p><br></p>") {
        this.form.body = "";
      }

      this.form.post(this.route('announcements.update', this.news.id), {
        onSuccess: () => {
          this.$toast.success('Announcement updated successfully!');
        }
      });
    }
  }
}
</script>

<style scoped>
.input-background { background-color: #f8f8f8; }
.menu1-background-color { background-color: #FAA43D; }
.validation_error_msg { font-weight: 400; margin: 6px 0 0 !important; color: red; }
</style>
